import React from "react";
import { Chip } from "@mui/material";

import { PredictionGapCategory } from "../Types/MLAnalyticsTypes";

interface DeviationBadgeProps {
  category: PredictionGapCategory | string | null | undefined;
}

const CATEGORY_CONFIG: Record<string, { label: string; color: "success" | "warning" | "error" | "default"; emoji: string }> = {
  Aligned: { label: "Aligned", color: "success", emoji: "\uD83D\uDFE2" },
  "Moderate Deviation": { label: "Moderate Deviation", color: "warning", emoji: "\uD83D\uDFE1" },
  "High Deviation": { label: "High Deviation", color: "error", emoji: "\uD83D\uDD34" },
  "Actual Not Available": { label: "No Actual Rating", color: "default", emoji: "\u26AA" },
};

/** Color-coded badge for `EmployeePrediction.prediction_gap_category`. */
const DeviationBadge: React.FC<DeviationBadgeProps> = ({ category }) => {
  const config = (category && CATEGORY_CONFIG[category]) || {
    label: category || "Unknown",
    color: "default" as const,
    emoji: "\u26AA",
  };

  return (
    <Chip
      size="small"
      color={config.color}
      variant={config.color === "default" ? "outlined" : "filled"}
      label={`${config.emoji} ${config.label}`}
    />
  );
};

export default DeviationBadge;
